import { ActionPlanType, Priority } from './Initiative';

export enum ResourceCategory {
  marketing = 'marketing',
  education = 'education',
  care = 'care',
}

export type CustomResource = {
  id?: string;
  // We cant rely on id as its CMS's id field which updates on every interaction with the instance, so we have to create our own identificator.
  // As crUuid is the only persistent unique identificator of the custom resource it is used instead of id
  crUuid?: string;
  crTitle?: string;
  actionPlanType?: keyof typeof ActionPlanType;
  crCategory?: ResourceCategory;
  crNote?: string;
  crDueDate?: string;
  crIsIncluded?: boolean;
  crPriority?: Priority;
  crType?: CrType;
  // `isChecked` indicates which resources should be assigned to the action plan.
  // This field is removed in `prepareCustomResourcesPayload`.
  isChecked?: boolean;
};

export enum CrType {
  retain = 'retain',
  recruit = 'recruit',
  both = 'both',
  retailRevenue = 'retail_revenue',
  serviceRevenue = 'service_revenue',
}
